import './Offer.css'
import Container from './Container.jsx'
import OfferCard from './OfferCard.jsx'
import image1 from '../img/offer/1.jpg'
import image2 from '../img/offer/2.jpg'
import image3 from '../img/offer/3.jpg'
const Offer = () => {
    return <div>
        <Container>
            <div className="card-row">
                <OfferCard image={image1} title={'Gyerek Edzések'} description={'Szórakoztató és biztonságos edzéseinkkel a gyerekek játékosan tanulják meg a judo alapjait és fejlesztik fizikai képességeiket.'} />
                <OfferCard image={image2} title={'Felnőtt Edzések'} description={'Felnőttek számára kínálunk intenzív edzéseket, melyek során fejleszthetik erejüket, rugalmasságukat és technikai tudásukat.'} />
                <OfferCard image={image3} title={'Versenyfelkészítés'} description={'Célzott felkészítéseink segítségével versenyzőink maximálisan ki tudják aknázni képességeiket és eredményesen szerepelnek a megmérettetéseken.'} />
            </div>
        </Container>
    </div>;
};

export default Offer;